<template>
    <v-menu
        v-if="!readonly"
        ref="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        style="background-color: white"
        min-width="340px"
    >
        <template v-slot:activator="{ on, attrs }">
            <input style="display: none" :name="name" v-model="fecha" />
            <v-text-field
                :readonly="readonly"
                @change="onChange($event)"
                :label="label"
                prepend-icon="mdi-calendar"
                v-model="fecha_altaesp"
                :rules="rules"
                :outlined="outlined"
                :dense="dense"
                v-bind="attrs"
                v-on="on"
                :hint="hint"
                :persistent-hint="persistentHint"
            ></v-text-field>
        </template>
        <v-date-picker
            first-day-of-week="1"
            v-model="fecha"
            no-title
            scrollable
            position="bottom"
        >
            <v-spacer></v-spacer>
            <v-btn
                text
                color="primary"
                @click="
                    fecha = null;
                    menu = false;
                "
            >
                Limpiar
            </v-btn>

            <v-btn text color="primary" @click="menu = false"> Cancelar </v-btn>
            <v-btn text color="primary" @click="$refs.menu.save(fecha)">
                OK
            </v-btn>
        </v-date-picker>
    </v-menu>
    <v-text-field
        v-else
        :readonly="readonly"
        :name="name"
        @change="onChange($event)"
        :label="label"
        prepend-icon="mdi-calendar"
        v-model="fecha_altaesp"
    ></v-text-field>
</template>
<script>
export default {
    props: [
        "label",
        "hint",
        "persistentHint",
        "value",
        "name",
        "readonly",
        "required",
        "rules",
        "outlined",
        "dense",
    ],
    data() {
        return { fecha: null, fecha_altaesp: "" };
    },
    created() {
        this.fecha = this.normalizeValue(this.value);
        if (this.fecha != null) {
            this.fecha_altaesp = this.formatDate(this.fecha);
        }
    },
    updated() {
        const normalized = this.normalizeValue(this.value);
        if (this.fecha != normalized) this.fecha = normalized;
    },
    watch: {
        value() {
            if (this.value == "0000-00-00") {
                this.$emit("input", null);

                this.fecha = null;
            } else {
                this.fecha = this.normalizeValue(this.value);
            }
        },
        fecha() {
            //console.log(this.fecha);
            this.fecha_altaesp = this.formatDate(this.fecha);
            this.$emit("input", this.fecha);
        },
    },
    computed: {
        /*fecha_altaesp(){
                return  this.formatDate(this.fecha);
            },*/
        inputListeners: function () {
            var vm = this;
            // `Object.assign` merges objects together to form a new object
            return Object.assign(
                {},
                // We add all the listeners from the parent
                this.$listeners,
                // Then we can add custom listeners or override the
                // behavior of some listeners.
                {
                    // This ensures that the component works with v-model
                    input: function (event) {
                        vm.$emit("input", event.target.value);
                    },
                }
            );
        },
    },
    methods: {
        normalizeValue(val) {
            if (!val) return null;
            if (typeof val === "string") {
                if (val === "0000-00-00") return null;
                // Acepta ISO (`YYYY-MM-DDTHH:mm:ss...`) y `YYYY-MM-DD`
                if (val.length >= 10) return val.slice(0, 10);
                return val;
            }
            return val;
        },
        formatDate(date) {
            if (!date) return null;

            const normalized = this.normalizeValue(date);
            if (!normalized) return null;
            const [year, month, day] = normalized.split("-");
            return `${day}/${month}/${year}`;
        },
        formatDateFromEsp(date) {
            if (!date) return null;
            //console.log(date);
            const [day, month, year] = date.split("/");
            //console.log(date);
            // Construir la fecha directamente en formato ISO sin conversión de zona horaria
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        onChange(event) {
            //console.log(this.fecha_altaesp);
            let regex =
                /^((((0[1-9]|[12][0-9]|3[01])([/])(0[13578]|10|12)([/])(\d{4}))|(([0][1-9]|[12][0-9]|30)([/])(0[469]|11)([/])(\d{4}))|((0[1-9]|1[0-9]|2[0-8])([/])(02)([/])(\d{4}))|((29)(\/)(02)([/])([02468][048]00))|((29)([/])(02)([/])([13579][26]00))|((29)([/])(02)([/])([0-9][0-9][0][48]))|((29)([/])(02)([/])([0-9][0-9][2468][048]))|((29)([/])(02)([/])([0-9][0-9][13579][26]))))$/;

            if (this.fecha_altaesp.match(regex)) {
                this.fecha = this.formatDateFromEsp(this.fecha_altaesp);
            } else {
                this.fecha_altaesp = this.formatDate(this.fecha);
            }
        },
    },
};
</script>
